export default "/_next/static/media/image-12-1024x294.a322a9a7aa5c275e8a222ba397253320.png";